import React, { ReactNode } from 'react';
import { styled } from '@mui/material/styles';
import { TextField, TextFieldProps } from '@mui/material';
import { useThemeTokens } from '../../../providers/themeTokenProvider';
import { useTextFieldTokens } from '../../2-component/textField/textField.tokens';
import { colors } from '../../0-tokens';
import { Typography } from '../../1-primative';

type OvLabelRebalance = {
  children: ReactNode;
};

const OvLabel = ({ children }: OvLabelRebalance) => <Typography variant='labelSmall' sx={{ mb: '4px' }}>{ children }</Typography>;

const CustomTextField = styled(TextField)(() => {
  const { sys, comp } = useThemeTokens(useTextFieldTokens());

  return {
    '& .MuiOutlinedInput-root': {
      height: '40px',
      fontSize: '16px',
      fontFamily: sys.font.base,
      fontWeight: 500,
      borderRadius: '4px',
      width: '100%',
      background: colors.white,

      '& input': {
        paddingLeft: '12px',
        paddingRight: '12px',
        color: comp.textField.textColor,
        fontSize: comp.textField.fontSize,
        fontWeight: comp.textField.fontWeight,
        textAlign: 'inherit',
        '&::placeholder': {
          textAlign: 'inherit',
        },
      },
      '&.hide-number-spinners input[type="number"]': {
        MozAppearance: 'textfield',
        '&::-webkit-inner-spin-button, &::-webkit-outer-spin-button': {
          WebkitAppearance: 'none',
          margin: 0,
        },
      },
      '&.Mui-focused fieldset': {
        borderColor: comp.textField.focusBorderColor,
      },
      '& fieldset': {
        borderColor: comp.textField.borderColor,
      },
      '&.MuiInputBase-adornedStart .MuiInputAdornment-positionStart': {
        marginRight: '0px',
      },
      '& .MuiSelect-select': {
        paddingLeft: '0px',
        marginLeft: '12px',
        marginRight: '12px',
        color: comp.textField.textColor,
        fontSize: comp.textField.fontSize,
        fontWeight: comp.textField.fontWeight,
      },
      '& .MuiInputAdornment-positionEnd': {
        marginLeft: '0px',
      },
      '&.Mui-error': {
        '& input': {
          color: comp.textField.errorColor,
        },
        '& fieldset': {
          borderColor: comp.textField.errorColor,
        },
      },
    },
  };
});

const OvTextField = ({ label, ...props }: TextFieldProps) => <><OvLabel>{ label }</OvLabel><CustomTextField {...props} label='' /></>;

export default OvTextField;
